import React, { useCallback, useEffect, useState } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// LOCAL VARIABLES
import { COMPONENTS } from '../../select/components/Components';

// STYLES
import styles from '../../select/select.module.scss';

// MAIN COMPONENT
const MultiValue = ({
  className,
  ...props
}) => {

  const {
    data: {
      value
    },
    selectProps: {
      validationSchema
    }
  } = props;

  const [error, setError] = useState();

  const validateDate = useCallback(
    async value => {
      setError(undefined);
      try {
        await validationSchema.validate(value);
      } catch (err) {
        setError(err);
      }
    },
    [validationSchema, setError]
  )

  useEffect(
    () => {
      validateDate(value)
    },
    [value, validateDate]
  )

  // RENDER
  return (
    <COMPONENTS.MultiValue className={clsx(
      error && styles.error,
      className
    )} {...props} />
  )
}

// EXPORT
export default MultiValue;
